import { useTranslation } from 'react-i18next'
import styles from './sociogram-teacher-page.module.scss'
import UserIcon from '@BUP/assets/Images/Data/students_icon.svg'
import PageLayout from '@BUP/components/Layout/Page'
import TitleDashboard from '@BUP/components/Generics/TitleDashboard'
import SociogramProviders from '@BUP/components/Sociogram/SociogramProviders'
import SociogramContentSwitcher from '@BUP/components/Sociogram/sociogram-content-switcher'
import { useContext } from 'react'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'

const SociogramTeacherPage = () => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.sociogram.teacher'
  })

  const term = useContext(CurrentTermContext)

  return (
    <PageLayout textColor='#17bebb'>
      <TitleDashboard
        icon={UserIcon}
        text={t('title')}
      />
      <p className={styles.intro_text}>{t('description')}</p>
      <SociogramProviders termId={term.id}>
        <div className={styles.content_wrapper}>
          <SociogramContentSwitcher />
        </div>
      </SociogramProviders>
    </PageLayout>
  )
}

export default SociogramTeacherPage
